<mat-form-field>
  <input matInput [placeholder]="placeholder" [(ngModel)]="autocompleteInput" (change)="onChange()" (keydown.enter)="onPostalAddressEnterKeyDown($event)">
</mat-form-field>
